import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FieldError, FieldInfo } from '../../../../hybrid/wrappers';
import FromInputTitle from '../FormFieldTitle/FormFieldTitle';
import css from './FormRate.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../common/utils/styles';
import { useRandom } from '../../../../common/utils/utils';
import Stars from '../../../stars/Stars';

const FormRate = (props) => {
    const { attribute, hint, required, title, compStyle = {}, value, info, errors, disabled, setFormData, options } = props;
    const random = useRandom();
    const fieldId = useMemo(() => {
        return `${attribute || ''}_${random}_field`;
    }, [attribute, random]);
    const { stylers, classes } = generateCompStylers(compStyle);
    const [val, setVal] = useState(value || '');

    useEffect(() => {
        setVal(value || 0);
    }, [value]);

    return (
        <div style={stylers.wrapper} className={classnames(css.formGroup, css['separated_title'], classes.wrapper)}>
            {!!title ? (
                <FromInputTitle
                    id={fieldId}
                    errors={errors}
                    title={title}
                    compStyle={{
                        ...compStyle,
                        title: {
                            className: classnames(classes?.title, css.title),
                            ...stylers?.title
                        }
                    }}
                    hint={hint}
                    required={required}
                    variationStyle={'separated_title'}
                    focused={false}
                />
            ) : null}
            <Stars
                disabled={disabled}
                value={val}
                attribute={attribute}
                setVal={setVal}
                setFormData={setFormData}
                options={options}
            />
            {!!info && <FieldInfo compStyle={compStyle?.info}>{info}</FieldInfo>}
            {errors && errors.length
                ? errors.map((err, idx) => (
                      <FieldError compStyle={compStyle?.error} key={`${attribute}${idx}`}>
                          {err}
                      </FieldError>
                  ))
                : null}
        </div>
    );
};
FormRate.propTypes = {
    attribute: PropTypes.string,
    hint: PropTypes.node,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    title: PropTypes.object,
    compStyle: PropTypes.object,
    value: PropTypes.string,
    setFormData: PropTypes.func,
    info: PropTypes.node,
    errors: PropTypes.array
};
export default FormRate;
